module.exports = __webpack_public_path__ + "img/password.7472f2cd.svg";